import { ReceiverTrafficPage } from '@apps-common/apps/portal/pages/receivers/pages/receiver-traffic/Index'

export const ReceiverTraffic = () => <ReceiverTrafficPage />
